import { Engine } from './Engine'
import { PerspectiveCamera } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GameEntity } from './GameEntity'

export class Camera implements GameEntity {
  public instance!: PerspectiveCamera
  private controls!: OrbitControls

  constructor(private engine: Engine) {
    this.initCamera()
    this.initControls()
  }

  private initCamera() {
    this.instance = new PerspectiveCamera(
      75,
      this.engine.canvas.width / this.engine.canvas.height,
      0.1,
      1000
    )
    this.instance.position.z = 100
    this.instance.position.y = 80
    this.engine.scene.add(this.instance)
  }

  private initControls() {
    // this.controls = new OrbitControls(this.instance, this.engine.canvas)
    this.controls = new OrbitControls(this.instance, this.engine.css2DRenderer.renderer.domElement)
    this.controls.update()
  }

  resize() {
    this.instance.aspect = this.engine.sizes.aspectRatio
    this.instance.updateProjectionMatrix()
  }

  update() {
    this.controls.update()
  }
}
